import React, { useEffect } from "react";
import FAQSection from '../components/FAQSection'
import HeroSection from '../components/Herosection'
import Footer from '../components/Footer'
import Header from '../components/Header'

const FAQ = () => {


    useEffect(() => {
        document.title = "FAQ | dawaacare";
    }, [])

    return (
        <div>
            <Header />
            <HeroSection />
            <FAQSection />
            <Footer />
        </div>
    )
}

export default FAQ